// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__e61ek","title":"CardHeader_title__NDhsD"};